import { Box, IBoxProps } from '../Box';

export const Center = ({ children, ...rest }: IBoxProps) => (
  <Box
    {...rest}
    direction="column"
    justifyContent="center"
    alignItems="center"
    alignSelf="center"
    justifySelf="center"
  >
    {children}
  </Box>
);
